import { CaseTypeTile, Icon } from '@core/designsystem';
import type { CaseListItem } from './types';

/**
 * Строка дела — метрики из docs/DESIGN.md, «Строка дела в списке».
 *
 * Три строки текста под плиткой типа: название, клиент с типом, ближайшее событие.
 * Высота выросла с заложенных 72 до 79 намеренно — юрист должен видеть ближайшее
 * заседание, не открывая дело.
 */
export function CaseRow({
  item,
  onOpen,
  onMenu,
  handle,
}: {
  item: CaseListItem;
  onOpen: () => void;
  onMenu?: () => void;
  /** Ручка перетаскивания — только в режиме своего порядка. */
  handle?: React.ReactNode;
}) {
  return (
    <div className="case-row">
      <button
        type="button"
        className="case-row__body"
        onClick={onOpen}
        onContextMenu={(event) => {
          if (!onMenu) return;
          event.preventDefault();
          onMenu();
        }}
      >
        <CaseTypeTile type={item.typeAccent} />

        <span className="case-row__texts">
          <span className="case-row__title">
            {item.isPinned ? (
              <Icon name="keep" filled size={16} className="case-row__pin" />
            ) : null}
            {item.title}
          </span>
          <span className="case-row__subtitle">{item.subtitle}</span>
          <span className={`case-row__status case-row__status--${item.accent}`}>
            <span className="case-row__dot" />
            {item.statusLine}
          </span>
        </span>
      </button>

      {handle}
    </div>
  );
}
